<div [formGroup]="formGroup" *ngIf="formGroup" class="w-full py-2">
  <div class="flex overflow-hidden w-full">
    <input
      #focusInput
      type="text"
      [(ngModel)]="domainInput"
      [ngModelOptions]="{standalone: true}"
      [placeholder]="fields.placeholder"
      #inputRef
      (keydown)="showError = ''"
      (keyup)="onKeyUpValidateFields(fields)"
      (keydown.enter)="onEnter(inputRef, $event)"
      class="input rounded-md px-4 py-2 text-2sm"
    />
    <button
      type="button"
      class="btn btn-primary bg-default-primary text-white px-4 py-2 text-sm font-medium cursor-pointer"
      (click)="addDomainFromControl(inputRef)"
    >
      <i class="ki-filled ki-plus-squared text-lg"></i>
    </button>
  </div>
  <span class="text-gray-500 text-2sm">{{ fields.helpText }}</span>

  <div class="flex flex-wrap gap-2 mb-3 mt-2">
    <div
      class="custom-tags flex items-center text-white text-sm px-3 py-1 rounded-md"
      *ngFor="let domain of inputWithTags; let i = index"
    >
      {{ domain }}
      <i class="ki-filled ki-cross text-lg ms-1" (click)="removeDomain(i)"></i>
    </div>
    <div *ngIf="showError" class="text-danger text-sm mt-1 w-full">
      {{ showError }}
    </div>
  </div>
</div>
